// extracted by mini-css-extract-plugin
module.exports = {"textWrapper":"PolicyContainer_textWrapper__a77cv"};